import { Injectable } from '@angular/core';
import { DemandeAffiliation } from '@lib/models/demande-affiliation/demande-affiliation.model';
import { DemandeAffiliationStatutBackOffice } from '@lib/models/demande-affiliation/types/demande-statut.type';
import { Pagination } from '@lib/models/pagination.model';
import { Observable } from 'rxjs';
import { BackOfficeTabsCounters } from '../models/backoffice-tabs-counters.model';

@Injectable()
export abstract class DemandeAffiliationBackOfficeService {
  public readonly aAffecterStatuts: DemandeAffiliationStatutBackOffice[] = ['a_affecter'];

  public readonly aControlerStatuts: DemandeAffiliationStatutBackOffice[] = [
    'a_controler',
    'controle_en_cours',
    'nc_traitee',
  ];

  public readonly enSignatureStatuts: DemandeAffiliationStatutBackOffice[] = [
    'en_signature',
    'relance',
    'affiliation_en_cours',
  ];

  public readonly enAttenteStatuts: DemandeAffiliationStatutBackOffice[] = [
    'nc_a_traiter',
  ];

  public readonly historiqueStatuts: DemandeAffiliationStatutBackOffice[] = [
    'expire',
    'affilie',
    'refuse',
    'annule',
  ];

  abstract watchDemandesCountByCategories(): Observable<BackOfficeTabsCounters>;
  abstract getDemandeAffiliations(
    search: string | null,
    statuts: DemandeAffiliationStatutBackOffice[],
    gestionnaireCodes: string[],
    pageIndex: number,
    pageSize: number,
    sortField: 'dateDeclaration' | 'dateUpdate',
    sortOrder: 'asc' | 'desc'
  ): Promise<Pagination<DemandeAffiliation>>;
  abstract affecterDemandeAffiliations(
    publicIds: string[],
    gestionnaireId: string
  ): Promise<void>;
  abstract refuserDemandeAffiliation(
    publicId: string,
    commentaire: string
  ): Promise<void>;

  abstract relancerSignature(
    publicId: string,
    newEmail: string | null,
    useNewEmailAsDefault: boolean,
    newNumber: string | null,
    useNewNumberAsDefault: boolean
  ): Promise<void>;
}
